<template>
    <div class="form-question clearfix" :class="'form-question-' + type">
        <template v-if="type === 'boolean'">
            <boolean-question ref="input" @change="changed" @focus="focus">
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </boolean-question>
        </template>

        <template v-if="type === 'selectbox'">
            <selectbox-question
                ref="input"
                @change="changed"
                @focus="focus"
                :options="options"
                :multiselect="multiselect"
            >
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </selectbox-question>
        </template>

        <template v-if="type === 'emotion'">
            <emotional-question
                ref="input"
                @change="changed"
                @focus="focus"
                :settings="settings || {}"
            >
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </emotional-question>
        </template>

        <template v-if="type === 'comment'">
            <comment-question ref="input" @change="changed" @focus="focus">
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </comment-question>
        </template>

        <template v-if="type === 'input'">
            <input-question ref="input" @change="changed" @focus="focus">
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </input-question>
        </template>

        <template v-if="type === 'nps'">
            <nps-question ref="input" @change="changed" @focus="focus">
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </nps-question>
        </template>
        <template v-if="type === 'date'">
            <date-question ref="input" @change="changed" @focus="focus">
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </date-question>
        </template>
        <template v-if="type === 'ces'">
            <ces-question ref="input" @change="changed" @focus="focus">
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </ces-question>
        </template>
        <template v-if="type === 'file'">
            <file-question
                ref="input"
                @change="changed"
                @focus="focus"
                :form-id="formId"
                :question-id="name"
                :link-code="linkCode"
                :settings="settings || {}"
            >
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </file-question>
        </template>
        <template v-if="type === 'table'">
            <table-question
                ref="input"
                @change="changed"
                @focus="focus"
                :settings="settings || {}"
            >
                <template slot="label">
                    <slot>{{ question }}</slot>
                </template>
            </table-question>
        </template>
        <template v-if="type === 'content'">
            <content-question ref="input" :body="question" />
        </template>
    </div>
</template>
<script>
export default {
    name: "form-question",
    props: {
        question: String,
        type: String,
        help: String,
        name: String,
        options: Array,
        multiselect: Boolean,
        settings: {},
        formId: [String, Number],
        linkCode: String,
    },
    data: function () {
        return {
            value: 5,
            tooltip: "",
        };
    },
    methods: {
        // fromChange: called while the person is still typing. Questions with
        // several fields (table) only re-check what they already flagged.
        isValid: function (fromChange) {
            let valid = this.$refs.input.isValid(fromChange);
            window.mixpanel?.track("Form question is valid", {
                type: this.type,
                question: this.question,
                valid: valid,
            });
            return valid;
        },
        getValue: function () {
            return this.$refs.input.getValue();
        },
        changed: function () {
            this.$emit("change", this);
        },
        getOffsetTop: function () {
            return this.$el.getBoundingClientRect().top + window.scrollY;
        },
        // The element to bring into view when the question is invalid.
        invalidElement: function () {
            const input = this.$refs.input;
            if (input && typeof input.firstInvalidElement === "function") {
                return input.firstInvalidElement() || this.$el;
            }
            return this.$el;
        },
        focus: function (question) {
            this.$emit("focus", this);
        },
        isNull: function () {
            return this.$refs.input.isNull();
        },
    },
};
</script>
